export default __webpack_public_path__ + "assets/images/f78f60e2929593b92a41a7f7290a8925.png";